<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex bg-primary justify-content-between">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">{{ 'redirect.home.page' | translate }}</label>
      <img alt="" class="home-logo" src="assets/images/mytwins-primary-logo.png" draggable="false" />
    </a>

    <div class="right-nav-mobile-menu">
      <div class="nav-item" *inPopulation="[populations.Default, populations.Partner, populations.Free]">
        <fgb-notification-button></fgb-notification-button>
      </div>

      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0"
        (click)="toggleMobileMenu()"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>
  <!-- NAV SCREEN -->
  <div
    #mobileMenu
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-menu-dropdown"
    [ngClass]="isFreePopulation ? 'bg-all-star' : 'bg-primary'"
  >
    <div class="d-flex flex-column">
      <div class="mobile-nav-header position-relative bg-primary">
        <!-- Accounts Menu Section -->
        <div class="d-flex align-items-center justify-content-start p-1">
          <img src="assets/images/mytwins-primary-logo.png" class="brand-logo" />
        </div>

        <!-- Close Button -->
        <button class="close-button border-0" attr.aria-label="{{ 'modal.close' | translate }}" (click)="toggleMobileMenu()">
          <span class="icon material-icons">close</span>
        </button>
      </div>
      <div *ngIf="memberDetails$ | async as memberDetails" class="container name-container">
        <div class="d-flex name-details-container">
          <div class="mb-0 text-uppercase text-white member-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</div>

          <ng-container *ngIf="memberCard$ | async as memberCard">
            <div class="text-white font-size-12">
              {{ memberCard?.ProductCodeDisplayName || membercard?.ProductCode }} - {{ memberCard.ExternalRefNumber }}
            </div>
          </ng-container>
        </div>

        <ng-container *inPopulation="[populations.Default, populations.Partner]">
          <img
            *ngIf="tierName == tierLevels.Mvp"
            alt=""
            src="assets/images/tier-logo/tier_logo_mvp.svg"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.AllStar"
            alt=""
            src="assets/images/tier-logo/tier_logo_all_star.svg"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.Legend"
            alt=""
            src="assets/images/tier-logo/tier_logo_legends.svg"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.Pro"
            alt=""
            src="assets/images/tier-logo/tier_logo_pro.svg"
            draggable="false"
            height="24"
          />
        </ng-container>
        <ng-container *inPopulation="[populations.Free]">
          <img
            *ngIf="tierName == tierLevels.Mvp"
            alt=""
            src="assets/images/tier-logo/tier_logo_mvp_white.png"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.AllStar"
            alt=""
            src="assets/images/tier-logo/tier_logo_all_star_white.png"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.Legend"
            alt=""
            src="assets/images/tier-logo/tier_logo_legends_white.png"
            draggable="false"
            height="24"
          />
          <img
            *ngIf="tierName == tierLevels.Pro"
            alt=""
            src="assets/images/tier-logo/tier_logo_pro_white.png"
            draggable="false"
            height="24"
          />
        </ng-container>
      </div>
      <div *ngIf="memberCard$ | async as memberCard">
        <ng-container *ngIf="memberCard.RetailDiscountLevel != null || memberCard.RetailDiscountLevel != undefined">
          <div class="container member-details d-flex align-items-center">
            <ng-container *inPopulation="[populations.Default, populations.Free, populations.Partner]">
              <div class="card-id" [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'">
                <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
                <div class="card-id-content">
                  <label class="text-heading mb-0">{{ pointsBalance$ | async | number: '1.0-0' }}</label>
                  <div class="font-size-12 text-white">{{ 'member.card.points.balance' | translate }}</div>
                </div>
              </div>

              <div class="card-id" [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'">
                <span class="icons material-symbols-outlined text-white money-bag-icon"> money_bag </span>
                <div class="card-id-content">
                  <label class="text-heading mb-0">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
                  <div class="font-size-12 text-white">{{ 'member.card.ecash.balance' | translate }}</div>
                </div>
              </div>
            </ng-container>
            <ng-container *inPopulation="[populations.Suite, populations.Pts]">
              <div class="card-id bg-glass">
                <span class="material-icons"> fastfood </span>
                <div class="card-id-content">
                  <!--Discount-->
                  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'"
                    ><label class="text-heading mb-0">{{ memberCard.DiscountLevel | getNumber }}%</label>
                  </ng-container>
                  <!--Discount Day F&B-->
                  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                    <label class="text-heading mb-0">{{ 'member.card.discount.day.fandb.value' | translate }}%</label>
                  </ng-container>

                  <div class="font-size-12 text-white">{{ 'mobile.nav.discountlevel' | translate }}</div>
                </div>
              </div>

              <div class="card-id bg-glass">
                <span class="material-icons"> local_mall </span>
                <div class="card-id-content">
                  <!--Retail Discount-->
                  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'"
                    ><label class="text-heading mb-0">{{ memberCard.RetailDiscountLevel | getNumber }}%</label></ng-container
                  >
                  <!--Discount Day Retail-->
                  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                    <label class="text-heading mb-0">{{ 'member.card.discount.day.retail.value' | translate }}%</label>
                  </ng-container>

                  <div class="font-size-12 text-white">{{ 'mobile.nav.discount' | translate }}</div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <ng-container *inPopulation="[populations.Default, populations.Free, populations.Partner]">
        <p class="container program-expire-container font-size-10 text-white text-center w-100">
          {{ 'member.card.program.expire' | translate }}
        </p>
      </ng-container>
      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container d-flex flex-column container">
        <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.account' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <ng-container *inPopulation="[populations.Suite]">
          <a
            class="nav-item"
            [routerLink]="['/partners']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.partner' | translate }}</div>
            <div class="material-icons icon me-0">navigate_next</div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[populations.Default, populations.Partner, populations.Free]">
          <a
            class="nav-item"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'rewards.nav.wallet' | translate }}</div>
            <div class="material-icons icon me-0">navigate_next</div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/rewards']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.rewards' | translate }}</div>
            <div class="material-icons icon me-0">navigate_next</div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
            <div class="material-icons icon me-0">navigate_next</div>
          </a>

          <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text">{{ 'nav.games' | translate }}</div>
            <div class="material-icons icon me-0">navigate_next</div>
          </a>

          <ng-container *inPopulation="[populations.Free]">
            <a
              class="nav-item"
              [routerLink]="['/earn']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.earn' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>

            <a
              class="nav-item"
              [routerLink]="['/partners']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.partner' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>

            <a
              class="nav-item"
              [routerLink]="['/referAFriend']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.refer.a.friend' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>
          </ng-container>

          <ng-container *inPopulation="[populations.Default, populations.Partner]">
            <a
              class="nav-item"
              [routerLink]="['/referAFriend']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.refer.a.friend' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>
            <a
              class="nav-item"
              [routerLink]="['/earn']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.earn' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>

            <a
              class="nav-item"
              [routerLink]="['/partners']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.partner' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>

            <a
              class="nav-item"
              [routerLink]="['/ecash-transfer']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.ecash.transfer' | translate }}</div>
              <div class="material-icons icon me-0">navigate_next</div>
            </a>
          </ng-container>
        </ng-container>

        <a class="nav-item" [routerLink]="['/contact']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text">{{ 'nav.faq' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <a class="nav-item" href="{{ 'mlb.privacy.url' | translate }}">
          <div class="nav-text">{{ 'nav.privacy.policy' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <a class="nav-item" href="{{ 'mlb.terms.url' | translate }}">
          <div class="nav-text">{{ 'nav.terms.use' | translate }}</div>
          <div class="material-icons icon me-0">navigate_next</div>
        </a>

        <a class="nav-item text-white" (click)="logout()">
          <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
        </a>

        <p class="font-size-14 text-white bottom-website-content">{{ 'mobile.nav.copy.right' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<!-- Non renewing -->

<div class="nr mobile-nav-menu d-flex position-fixed flex-column d-lg-none" *inPopulation="[populations.NonRenewingPopulation]">
  <div class="mobile-nav-bar d-flex bg-primary align-items-center justify-content-between">
    <a class="nav-item fw-bold brand p-1 nonrenew" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">{{ 'redirect.home.page' | translate }}</label>
      <img alt="" class="home-logo" src="assets/images/MyTwins_PrimaryLogo_Light.png" draggable="false" />
    </a>
  </div>
</div>
